// b24-1: temperaturen inne, samma värde och samma regel överallt: översikten (platskortet och
// rapporten), kortet Inne på platsens detaljsida och Hälsa.
//   1. husets egen givare hus.inne.temp, om den finns;
//   2. annars medelvärdet av alla zoner som rapporterar en temperatur (hus.zon.temp@<zon>), och då
//      anges hur många rum medelvärdet gäller ("medel av 3 rum"). Dolda zoner (en värmepumps
//      utegivare, signalen dold.hus.zon.temp) räknas inte.

import type { Signalvarde } from "./typer.ts";

export interface Innetemperatur {
  varde: number;
  /** Antalet zoner (rum) som medelvärdet gäller, eller null när värdet kommer från husets givare. */
  rum: number | null;
}

/** Temperaturen inne och varifrån den kommer, eller null om varken givaren eller någon zon har ett värde. */
export function inneTemperatur(signaler: Record<string, Signalvarde>): Innetemperatur | null {
  const inne = signaler["hus.inne.temp"]?.varde;
  if (typeof inne === "number") return { varde: inne, rum: null };
  const zoner = Object.entries(signaler)
    .filter(([k, v]) => k.startsWith("hus.zon.temp@") && typeof v.varde === "number")
    .map(([, v]) => v.varde as number);
  return zoner.length > 0
    ? { varde: zoner.reduce((a, b) => a + b, 0) / zoner.length, rum: zoner.length }
    : null;
}

/** Källan i liten text: "medel av 3 rum", eller null när värdet kommer från husets givare. */
export function inneKalla(i: Innetemperatur): string | null {
  return i.rum === null ? null : `medel av ${i.rum} rum`;
}
